import Vue from "vue";
export default Vue.extend({
    props: {
        value: Number,
    },
    computed: {
        width() {
            return `${this.value}%`;
        },
    },
});
